import * as React from 'react';
import { styled } from '@mui/system';
import NoteCardDetail from './NoteCardDetail';

const Cards = styled('div')({
  background: 'transparent',
  display: 'flex',
  gap: '20px',
  flexWrap: 'wrap',
  flexDirection: 'row',
  width: '370px',
  padding: '0 3px 0 3px',
  height: 'auto',
});

const NotesCard = ({ noteCardData, displayName }) => {
  const NoteCards = () => {
    if (!noteCardData) return '';
    return noteCardData.map((data, key) => (
      <NoteCardDetail key={key} {...data} displayName={displayName} />
    ));
  };

  return (
    <Cards>
      <NoteCards />
    </Cards>
  );
};

export default NotesCard;
